/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const headerLoginRegisterPanelMenuCustomSX = (theme: Theme): SxProps => ({
	alignSelf: 'center',
	width: '385px',
	[theme.breakpoints.down('lg')]: {
		width: '100%',
	},
});

export const headerLoginRegisterDrawerContainerSX: SxProps = {
	'& .MuiDrawer-paper': {
		maxHeight: '80vh',
		zIndex: '1600',
		bottom: '60px',
		boxShadow: 3,
		transition: 'none',
	},
};

export const loginRegisterPanelTitleBoxSX: SxProps = {
	justifyContent: 'space-between',
	flexDirection: 'row',
	display: 'flex',
	p: '15px 20px',
	alignItems: 'center',
};

export const loginRegisterPanelTitleIconXS: SxProps = {
	mr: '5px',
	fontVariationSettings: '"FILL" 1',
	color: 'primary.main',
};

export const loginRegisterPanelCloseIconXS: SxProps = {
	cursor: 'pointer',
	'&:hover': {
		color: 'primary.main',
	},
};

export const loginRegisterPanelTitleSX: SxProps = {
	width: '100%',
	fontSize: '18px',
};

export const loginRegisterPanelBoxPaperSX: SxProps = {
	width: '100%',
	p: '15px 20px',
};
